/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerPriceGroupService = {
  async getByCustomerCode(customerCode) {
    const requestScreenData = {
      url: "api/CustomerPriceGroup",
      filter: `CustomerCode eq '${customerCode}' and Include eq true`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getPriceGroupList() {
    const requestScreenData = {
      url: "api/PriceGroupList",
      filter: `Inactive eq 'N'`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async save(payload) {
    return await ApiService.post("api/CustomerPriceGroup/save", payload);
  },


  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { CustomerPriceGroupService };
